import { EMPTY_OBJ } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useCisUsersList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'cisUsers', api: api.cisUsers }, queryVariables, queryConfig);

  return {
    cisUsers: queryResult.resolvedData,
    latestCisUsers: queryResult.latestData,
    ...queryResult,
  };
};

export const useCisUser = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['cisUser', { id }], api.cisUsers.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    cisUser: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useUnapproveCisUserByEvent = ({ eventId }, queryConfig = {}) => {
  const queryResult = useQuery(['cisUser', { eventId }], api.cisUsers.unapproveByEvent, {
    ...queryConfig,
  });

  return {
    data: queryResult.data || {},
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'cisUsers' });

export const useCreateCisUser = createMutation(api.cisUsers.create);

export const useUpdateCisUser = createMutation(api.cisUsers.update);

export const useUploadCisUsers = createMutation(api.cisUsers.upload);

export const useApproveCisUser = createMutation(api.cisUsers.approve);

export const useUnapproveCisUser = createMutation(api.cisUsers.unapprove);
